var _radialGradient, _circle, _linearGradient, _circle2, _radialGradient2, _path, _radialGradient3, _circle3, _radialGradient4, _circle4, _radialGradient5, _path2, _radialGradient6, _path3, _linearGradient2, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFearfulFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "100px",
    height: "100px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "KtiGG9C9GcEo~okKgiA_ea",
    cx: -112,
    cy: 24,
    r: 18,
    fx: -112.095,
    fy: 16.289,
    gradientTransform: "matrix(-1 0 0 1 -88 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe16e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#ffd426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#fdcd23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#f8b919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f09c0c"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 18,
    fill: "url(#KtiGG9C9GcEo~okKgiA_ea)"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "KtiGG9C9GcEo~okKgiA_eb",
    x1: 24,
    x2: 24,
    y1: 6.253,
    y2: 29.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6eafff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ee4ff",
    stopOpacity: 0
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 18,
    fill: "url(#KtiGG9C9GcEo~okKgiA_eb)"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "KtiGG9C9GcEo~okKgiA_ec",
    cx: 839.997,
    cy: -936.416,
    r: 8.414,
    gradientTransform: "matrix(-1 0 0 -.3754 864 -319.094)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c1911"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#171714"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#KtiGG9C9GcEo~okKgiA_ec)",
    d: "M18.356,33.929l-1.292-1.285c0,0,2.111-5.643,6.935-5.643s6.941,5.658,6.941,5.658 l-1.254,1.288c0,0-2.715-0.947-5.687-0.947S18.356,33.929,18.356,33.929z"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "KtiGG9C9GcEo~okKgiA_ed",
    cx: 30,
    cy: 32.441,
    r: 1.771,
    gradientTransform: "matrix(-1 0 0 -.3754 60 44.618)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c1911"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#171714"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 33,
    r: 1,
    fill: "url(#KtiGG9C9GcEo~okKgiA_ed)"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "KtiGG9C9GcEo~okKgiA_ee",
    cx: 18,
    cy: 32.441,
    r: 1.771,
    gradientTransform: "matrix(-1 0 0 -.3754 36 44.618)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c1911"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#171714"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 33,
    r: 1,
    fill: "url(#KtiGG9C9GcEo~okKgiA_ee)"
  })), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "KtiGG9C9GcEo~okKgiA_ef",
    cx: 63.964,
    cy: 31.566,
    r: 3.551,
    gradientTransform: "matrix(.0176 .9997 -3.6937 .1086 139.475 -35.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.724,
    stopColor: "#ffe16e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    stopColor: "#ffe16e",
    stopOpacity: 0
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#KtiGG9C9GcEo~okKgiA_ef)",
    d: "M18.115,34.033c0,0,1.721,0.967,5.884,0.967c3.856,0,5.83-0.967,5.83-0.967S27.267,33,24,33 S18.115,34.033,18.115,34.033z"
  })), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "KtiGG9C9GcEo~okKgiA_eg",
    cx: 839.93,
    cy: -936.993,
    r: 6.206,
    gradientTransform: "matrix(-1 0 0 -.4899 864 -426.085)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.041,
    stopColor: "#cc9000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.284,
    stopColor: "#cc9000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc9000",
    stopOpacity: 0
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#KtiGG9C9GcEo~okKgiA_eg)",
    d: "M24,34c5.488,0,6.221,0.005,6.221,0.005S28.779,36,24,36s-6.081-1.967-6.081-1.967 S18.512,34,24,34z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "KtiGG9C9GcEo~okKgiA_eh",
    x1: 19.887,
    x2: 28.099,
    y1: 29,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#968f72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.048,
    stopColor: "#b2ad97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.098,
    stopColor: "#cac6b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.153,
    stopColor: "#dddbd2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.213,
    stopColor: "#ecebe6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#f7f6f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#fdfdfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.637,
    stopColor: "#fdfdfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#f7f6f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.787,
    stopColor: "#ecebe6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847,
    stopColor: "#dddbd2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    stopColor: "#cac6b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#b2ad97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#968f72"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#KtiGG9C9GcEo~okKgiA_eh)",
    d: "M19.887,30h8.212c-0.977-1.063-2.335-2-4.099-2C22.222,28,20.862,28.938,19.887,30z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#4f6980",
    d: "M36.093,17.791c-0.449-0.501-1.075-0.982-1.701-1.354c-0.637-0.379-1.317-0.679-2.017-0.911 c-0.709-0.209-1.427-0.38-2.163-0.451c-0.732-0.089-1.474-0.086-2.211-0.06l-0.035,0.001c-0.562,0.02-1.034-0.419-1.054-0.981 c-0.02-0.562,0.419-1.034,0.981-1.054c0.036-0.001,0.073-0.001,0.108,0.002c0.844,0.06,1.685,0.151,2.511,0.343 c0.828,0.173,1.633,0.457,2.41,0.785c0.771,0.351,1.505,0.776,2.178,1.284c0.677,0.52,1.276,1.069,1.807,1.813 c0.16,0.224,0.108,0.535-0.116,0.695c-0.209,0.149-0.493,0.114-0.661-0.073L36.093,17.791z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#4f6980",
    d: "M11.093,17.209c0.531-0.744,1.131-1.293,1.807-1.813c0.673-0.508,1.408-0.934,2.178-1.284 c0.777-0.328,1.582-0.612,2.41-0.785c0.826-0.192,1.667-0.284,2.511-0.343c0.561-0.04,1.048,0.383,1.088,0.944 c0.04,0.561-0.383,1.048-0.944,1.088c-0.036,0.003-0.072,0.003-0.107,0.002L20,15.016c-0.737-0.026-1.479-0.03-2.211,0.06 c-0.736,0.07-1.454,0.241-2.163,0.451c-0.7,0.232-1.381,0.531-2.017,0.911c-0.627,0.371-1.252,0.853-1.701,1.354l-0.037,0.041 c-0.184,0.205-0.499,0.222-0.704,0.038C10.975,17.699,10.947,17.413,11.093,17.209z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13,22c0-2.209,1.791-4,4-4s4,1.791,4,4c0,0-1.791,1-4,1S13,22,13,22z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M18.844,22.776C18.944,22.537,19,22.275,19,22c0-1.105-0.895-2-2-2s-2,0.895-2,2 c0,0.275,0.056,0.537,0.156,0.776C15.71,22.904,16.331,23,17,23S18.29,22.904,18.844,22.776z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35,22c0-2.209-1.791-4-4-4s-4,1.791-4,4c0,0,1.791,1,4,1S35,22,35,22z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M29.156,22.776C29.056,22.537,29,22.275,29,22c0-1.105,0.895-2,2-2s2,0.895,2,2 c0,0.275-0.056,0.537-0.156,0.776C32.29,22.904,31.669,23,31,23S29.71,22.904,29.156,22.776z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFearfulFace);
export default __webpack_public_path__ + "static/media/fearful-face.92f04afd474ba624fea48f373b6c576d.svg";
export { ForwardRef as ReactComponent };